import { type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	type: "youtube" | "vimeo"
	videoId: string
	className?: string
}
const VideoPreview: FC<Props> = ({ type, videoId, className }) => {
	const src =
		type === "youtube"
			? `https://www.youtube-nocookie.com/embed/${videoId}`
			: `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0`

	return (
		<iframe
			src={src}
			title={`${type === "youtube" ? "YouTube" : "Vimeo"} video preview`}
			tabIndex={-1}
			aria-hidden="true"
			className={cn("pointer-events-none aspect-video w-full border-none", className)}
		/>
	)
}

export default VideoPreview
